import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableSessionUsageComponent } from './table-session-usage.component';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ReportSessionUsageModalModule } from '../modals/report-session-usage/report-session-usage-modal.module';
import { CustomizableTableModule } from 'pod-ng-core';

@NgModule({
  declarations: [TableSessionUsageComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    CustomizableTableModule,
    ReportSessionUsageModalModule,
  ],
  exports: [TableSessionUsageComponent],
  providers: [],
})
export class TableSessionUsageModule {}
